import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"];

  connect() {
    // Listen for clicks outside the dropdown to close it
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
  }

  toggle(event) {
    event.stopPropagation(); // Prevent the event from reaching document
    const menus = document.querySelectorAll("[data-dropdown-target='menu']");
    for (var i = 0; i < menus.length; ++i) {
      menus[i].classList.add('hidden');
    }
    this.menuTarget.classList.toggle("hidden");
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
